import { companyGateway } from '~/gateways/companyGateway';
import { MagicUseCase } from './magicUseCase';

export class GetCompanyInfoUseCase extends MagicUseCase {
  protected async runLogic(domain: string) {
    const companyInfo = await companyGateway.getCompanyInfo(domain);
    this.getState().user.companyInfo = companyInfo;
  }
}
